import { Component } from '@angular/core';

@Component({
  selector: 'rmi-ivr-report-skeleton',
  templateUrl: './ivr-report-skeleton.component.html',
  styleUrls: ['./ivr-report-skeleton.component.scss'],
})
export class IvrReportSkeletonComponent {}
